var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from 'react';
import { Play } from '@volkswagen-onehub/icons-core';
import { MediaContext } from '..';
import { CTA } from '../../call-to-action';
import { styled } from '../../theme-provider';
const StyledPlayButtonCenter = styled(CTA).withConfig({ displayName: "StyledPlayButtonCenter", componentId: "sc-14knx0f" }) `position:absolute;left:50%;top:50%;transform:translate(-50%, -50%);`;
export const PlayButtonCenter = (_a) => {
    var { playTitle } = _a, rest = __rest(_a, ["playTitle"]);
    const mediaElement = React.useContext(MediaContext);
    const [isPlaying, setIsPlaying] = React.useState(false);
    const handlePlay = React.useCallback(() => {
        setIsPlaying(true);
    }, []);
    const handleEnded = React.useCallback(() => {
        setIsPlaying(false);
    }, []);
    React.useEffect(() => {
        mediaElement === null || mediaElement === void 0 ? void 0 : mediaElement.addEventListener('play', handlePlay);
        mediaElement === null || mediaElement === void 0 ? void 0 : mediaElement.addEventListener('ended', handleEnded);
        return () => {
            mediaElement === null || mediaElement === void 0 ? void 0 : mediaElement.removeEventListener('play', handlePlay);
            mediaElement === null || mediaElement === void 0 ? void 0 : mediaElement.removeEventListener('ended', handleEnded);
        };
    }, [handleEnded, handlePlay, mediaElement]);
    const handleClick = React.useCallback((event) => {
        if (mediaElement) {
            event.preventDefault();
            event.stopPropagation();
            mediaElement.play();
        }
    }, [mediaElement]);
    if (isPlaying) {
        return null;
    }
    return (React.createElement(StyledPlayButtonCenter, Object.assign({ tag: "button", emphasis: "tertiary", onClick: handleClick, title: playTitle, "aria-label": playTitle, icon: React.createElement(Play, { ariaHidden: true }) }, rest)));
};
PlayButtonCenter.displayName = 'PlayButtonCenter';
